export const Linking9089 = `
... on Form9141DataDatahub {
    _blsCounties
    altPwdWageRate
    altPwdUnitOfPay
    formVersionId
    formId
    suggestedSocCode
    pwdLinkingSocCode
    suggestedSocTitle
    pwdSocTitle
    jobTitle
    cba
    empBusinessName
    empTradeName
    empAddr1
    empAddr2
    empCity
    empState
    empPostcode
    empCountry
    empProvince
    empPhone
    empPhoneext
    empFein
    empNaics
    empNaicsDesc
    empExperienceRequired
    highestPwd
    altEmpExperienceReqd
    isSpecialRequirements
    isSpecReqLicenseCert
    jobDuties
    primaryEducationLevel
    trainingRequired
    specialRequirements
    specReqLicenseCert
    specReqForeignLang
    specReqResFellow
    specReqOther
    numberOfMonthsTraining
    superviseOtherEmp
    superviseHowMany
    empExperienceMonths
    primaryWorksiteAddr1
    primaryWorksiteAddr2
    primaryWorksiteCity
    primaryWorksiteState
    primaryWorksitePostalCode
    primaryWorksiteCounty{
        value
        label
    }
    primaryWorksiteBlsArea
    caseNumber
    otherWorksiteLocation
    otherWorksites{
        rowNum
        worksiteCity
        worksiteState
        worksitePostalCode
        worksiteCountyTownship
        worksiteCountyOrBlsArea
        worksiteBlsArea
        worksiteBlsAreaId
        prevailingWage
        pwUnitOfPay
        altPrevailingWage
        altPwUnitOfPay
        sort_order
    }
    caseStatus
    pwdWageRate
    pwdUnitOfPay

    attyRepresentType
    attyLastname
    attyFirstname
    attyMiddlename
    attyAddr1
    attyAddr2
    attyCity
    attyState
    attyPostcode
    attyCountry
    attyProvince
    attyPhone
    attyPhoneext
    attyEmail
    attyBizname
    attyFein

    primaryWorksiteState
    requestorPocLastName
    requestorPocFirstName
    requestorPocMiddleName
    requestorPocJobTitle
    requestorPocAddr1
    requestorPocAddr2
    requestorPocCity
    requestorPocState
    requestorPocPostalCode
    requestorPocCountry
    requestorPocProvince
    requestorPocPhone
    requestorPocPhoneExt
    requestorPocEmail

    dateSubmitted
    caseDeterminDate
    caseMetadata {
        determinationDate
    }
}
`;
